import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Player from '../..';
import {
  AltiboxAsset,
  HeaderDisplayType,
  HeaderInteractionType,
  ImageAspectRatioType,
  StreamType,
} from '../../../../interfaces';
import { getAggregatedTitleImage } from '../../../../queries/ats/common';
import { PlayData } from '../../../../queries/ats/playback/api';
import { PlayablePlaybackOption } from '../../../../queries/ats/titles/types/playback-option';
import { PlayableTitle } from '../../../../queries/ats/titles/types/title';
import { tracker } from '../../../../tracker';
import { PlaybackEndedEvent } from '../../../../tracker/events/playback-ended';
import Header from '../../../../views/app/Header';
import StickyHeader from '../../../../views/app/StickyHeader';
import FullscreenMessage from '../../../FullscreenMessage';
import { PlayerCard } from '../player-card';

interface TrailerPlayerProps {
  data: PlayData;
  title: PlayableTitle;
  playbackOption: PlayablePlaybackOption;
  position: number | undefined;
}

export function TrailerPlayer({ data, title, playbackOption, position = 0 }: TrailerPlayerProps) {
  const shouldFadeOut = useSelector((state) => state.app.shouldFadeOut);
  const isGuest = useSelector((state) => state.authReducer.isGuest);
  const history = useHistory();
  const { t } = useTranslation();

  const stream = {
    manifestUrl: data.url,
    licenseUrl: data.licenseUrl,
    customData: data.token,
    platform: data.platform,
    account: data.account,
    releasePid: data.releasePid,
  };

  if (isGuest) {
    return (
      <FullscreenMessage
        backgroundImage={getAggregatedTitleImage(title.masterId, ImageAspectRatioType.WIDE, 1100)}
        showLoginButton={true}
      >
        <StickyHeader />
        <Header displayType={HeaderDisplayType.NoStickyGradient} interactionType={HeaderInteractionType.CloseOnly} />
        <p>{t('log in to see trailer')}</p>
      </FullscreenMessage>
    );
  }
  return (
    <div className="ats-player">
      <StickyHeader />
      <Header
        displayType={HeaderDisplayType.Player}
        interactionType={HeaderInteractionType.Back}
        closeCallback={() => {
          history.goBack();
        }}
      />

      {!shouldFadeOut && <PlayerCard title={title} />}

      <Player
        stream={{
          isGuest: isGuest,
          streamType: StreamType.TRAILER,
          mediaId: undefined,
          contentId: '',
          playData: stream,
          startBookmark: position,
        }}
        onUnmount={(event) => {
          tracker.track(new PlaybackEndedEvent(title, playbackOption, event.position, true));
        }}
        onConcurrencyError={() => Function}
        hideControls={shouldFadeOut}
        onAlert={() => Function}
        onPlayerError={() => Function}
        onEnded={() => history.goBack()}
        onPlaying={() => Function}
        onPause={() => Function}
        currentAsset={{} as AltiboxAsset}
      />
    </div>
  );
}
